// Site locales that are not the language's code to Intl: `dk` is no language, and `se` is Northern
// Sami, whose "two" plural form a {{singular|plural}} translation leaves empty.
const INTL_LOCALES = {'dk': 'da', 'se': 'sv'},

      /**
       * The Intl locale of the site language, for plural rules and number formatting.
       * @returns {string}
       */
      intlLocale = () => {
	      const {siteLocale} = globalThis.globalParams;

	      return INTL_LOCALES[siteLocale] ?? siteLocale;
      };

export default intlLocale;